export const setOtherPermissions = (state, action) => ({
  ...state,
  ...action,
});
